export default {
  // General
  'app.name': 'Soulidari',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.success': 'Success!',
  'common.error': 'Error',
  'common.close': 'Close',
  'common.confirm': 'Confirm',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.yes': 'Yes',
  'common.no': 'No',
  
  // Profile
  'profile.title': 'My Profile',
  'profile.subtitle': 'Manage your personal information',
  'profile.edit': 'Edit Profile',
  'profile.name': 'Name',
  'profile.email': 'Email',
  'profile.phone': 'Phone',
  'profile.password': 'New Password',
  'profile.passwordPlaceholder': '••••••••',
  'profile.passwordHint': 'leave empty to keep current',
  'profile.language': 'Language',
  'profile.languageHelp': 'Choose the interface language',
  'profile.lastLogin': 'Last Login',
  'profile.saveSuccess': 'Profile updated successfully!',
  'profile.languageSuccess': 'Language changed! Reloading...',
  
  // Layout
 'layout.masterDashboard': 'Master Dashboard',
'layout.companies': 'Companies',
'layout.allCompanies': 'All Companies',
'layout.system': 'System',
'layout.systemUsers': 'System Users',
'layout.auditLogs': 'Audit Logs',
'layout.dashboard': 'Dashboard',
'layout.myDashboard': 'My Dashboard',
'layout.attendance': 'Attendance',
'layout.conversations': 'Conversations',
'layout.myConversations': 'My Conversations',
'layout.contacts': 'Contacts',
'layout.tasks': 'Tasks',
'layout.myTasks': 'My Tasks',
'layout.chatbot': 'Chatbot',
'layout.visualFunnel': 'Visual Funnel',
'layout.crm': 'CRM',
'layout.leads': 'Leads',
'layout.monitoring': 'Monitoring',
'layout.teamPerformance': 'Team Performance',
'layout.appointments': 'Appointments',
'layout.biIntegration': 'BI Integration',
'layout.achievements': 'Achievements',
'layout.myPerformance': 'My Performance',
'layout.administration': 'Administration',
'layout.users': 'Users',
'layout.sectors': 'Sectors',
'layout.phoneNumbers': 'WhatsApp Numbers',
'layout.communication': 'Communication',
'layout.templates': 'Templates',
'layout.bulkMessaging': 'Bulk Messaging',
'layout.automations': 'Automations',
'layout.aiAgents': 'AI Agents',
'layout.optIn': 'Opt-in Management',
'layout.reports': 'Reports',
'layout.businessAccounts': 'Business Accounts',
'layout.profile': 'My Profile',
'layout.settings': 'Settings',
'layout.logout': 'Logout',
'layout.fullControl': 'Full system control',
'layout.status': 'Status',
'layout.online': 'Online',
'layout.accessRestricted': 'Access Restricted',
'layout.featureNotAvailable': 'Feature not available in your plan',
'layout.currentPlan': 'Current plan',
'layout.upgradeToUnlock': 'This feature is available in higher plans.',
'layout.contactSupport': 'Contact support to upgrade your plan and unlock this feature.',
'layout.viewPlans': 'View Plans',
  
 // Dashboard
'dashboard.helloOperator': 'Hello, {name}',
'dashboard.operator': 'Operator',
'dashboard.welcome': 'Welcome to Dashboard',
'dashboard.operatorSubtitle': 'Track your service performance',
'dashboard.subtitle': 'Track your company performance in real-time.',
'dashboard.viewReports': 'View Reports',
'dashboard.newCampaign': 'New Campaign',
'dashboard.errorLoading': 'Error loading data',
'dashboard.tryAgain': 'Try Again',
'dashboard.yourStats': 'Your Statistics',
'dashboard.keepGoodWork': 'Keep up the great work!',
'dashboard.total': 'Total',
'dashboard.resolved': 'Resolved',
'dashboard.avgTime': 'Avg Time',
'dashboard.totalConversations': 'Total Conversations',
'dashboard.activeNow': 'active now',
'dashboard.totalMessages': 'Total Messages',
'dashboard.today': 'today',
'dashboard.activeConversations': 'Active Conversations',
'dashboard.inProgress': 'In progress now',
'dashboard.avgResponseTime': 'Avg Response Time',
'dashboard.conversationsToday': 'conversations today',
'dashboard.advancedReports': 'Advanced Reports',
'dashboard.detailedMetrics': 'Detailed performance metrics',
'dashboard.viewReportsArrow': 'View Reports →',
'dashboard.leadsCRM': 'Leads CRM',
'dashboard.manageLeads': 'Manage your leads and opportunities',
'dashboard.manageLeadsArrow': 'Manage Leads →',
'dashboard.automations': 'Automations',
'dashboard.configureAuto': 'Configure automatic responses',
'dashboard.configureArrow': 'Configure →',
'dashboard.recentConversations': 'Recent Conversations',
'dashboard.viewAll': 'View all',
'dashboard.contact': 'Contact',
'dashboard.lastMessage': 'Last Message',
'dashboard.dateTime': 'Date/Time',
'dashboard.status': 'Status',
'dashboard.actions': 'Actions',
'dashboard.loadingConversations': 'Loading conversations...',
'dashboard.noConversations': 'No conversations found.',
'dashboard.user': 'User',
'dashboard.noMessages': 'No messages',
'dashboard.statusActive': 'Active',
'dashboard.statusClosed': 'Closed',
'dashboard.statusPending': 'Pending',
'dashboard.openChat': 'Open Chat',

 // Conversations
'conversations.tabAll': 'All',
'conversations.tabOpen': 'Open',
'conversations.tabPending': 'Pending',
'conversations.tabClosed': 'Closed',
'conversations.searchPlaceholder': 'Search by name or number...',
'conversations.allSectors': 'All Sectors',
'conversations.allInSector': 'All in Sector',
'conversations.selectSectorFirst': 'Select a sector first',
'conversations.allNumbers': 'All Numbers',
'conversations.noSector': 'No sector',
'conversations.noResults': 'No conversations found.',
'conversations.clearFilters': 'Clear filters',
'conversations.noMessages': 'No messages',
'conversations.total': 'Total',
'conversations.open': 'Open',
'conversations.pending': 'Pending',
'conversations.closed': 'Closed',
'conversations.selectConversation': 'Select a conversation',
'conversations.chooseToStart': 'Choose a conversation to start',
'conversations.tip': 'Tip',
'conversations.tip1': 'Use filters to view conversations by sector',
'conversations.tip2': 'Select a sector to filter by attendant',
'conversations.tip3': 'Search by contact name or number',
  
  // Contacts
'contacts.title': 'Contacts',
'contacts.subtitle': 'Manage your contact base',
'contacts.total': 'Total',
'contacts.searchPlaceholder': 'Search by name or phone...',
'contacts.all': 'All',
'contacts.optInOnly': 'Opt-in Only',
'contacts.optOutOnly': 'Opt-out Only',
'contacts.selectAtLeastOne': 'Select at least one contact',
'contacts.name': 'Name',
'contacts.notInformed': 'Not informed',
'contacts.phone': 'Phone',
'contacts.createdIn': 'Created on',
'contacts.selectedContacts': '{count} contact(s) selected',
'contacts.clear': 'Clear',
'contacts.sendToBulk': 'Send to Bulk',
'contacts.contact': 'Contact',
'contacts.createdAt': 'Created',
'contacts.actions': 'Actions',
'contacts.loadingContacts': 'Loading contacts...',
'contacts.noResults': 'No contacts found',
'contacts.tryAdjustFilters': 'Try adjusting filters',
'contacts.contactsWillAppear': 'Contacts will appear here',
'contacts.noName': 'No name',
'contacts.viewDetails': 'View details',
'contacts.sendToCampaign': 'Send to campaign',
'contacts.showing': 'Showing',
'contacts.of': 'of',
'contacts.contacts': 'contacts',
'contacts.selectedCount': '{count} selected',
  
// Leads
'leads.title': 'Leads CRM',
'leads.subtitle': 'Manage your leads and track the sales funnel',
'leads.newLead': 'New Lead',
'leads.total': 'Total',
'leads.statusNew': 'New',
'leads.statusContacted': 'Contacted',
'leads.statusQualified': 'Qualified',
'leads.statusConverted': 'Converted',
'leads.statusLost': 'Lost',
'leads.sourceManual': 'Manual',
'leads.sourceWebsite': 'Website',
'leads.sourceCampaign': 'Campaign',
'leads.searchPlaceholder': 'Search by name, phone or email...',
'leads.allStatuses': 'All statuses',
'leads.filter': 'Filter',
'leads.name': 'Name',
'leads.contact': 'Contact',
'leads.status': 'Status',
'leads.source': 'Source',
'leads.responsible': 'Responsible',
'leads.sector': 'Sector',
'leads.actions': 'Actions',
'leads.noResults': 'No leads found.',
'leads.confirmDelete': 'Are you sure you want to delete this lead?',
'leads.errorDelete': 'Error deleting',
'leads.editLead': 'Edit Lead',
'leads.phone': 'Phone',
'leads.email': 'Email',
'leads.noResponsible': 'No responsible',
'leads.noSector': 'No sector',
'leads.lostReason': 'Loss reason',

// Team Performance
'teamPerformance.title': 'Team Performance',
'teamPerformance.subtitle': 'Track all attendants performance',
'teamPerformance.last7days': 'Last 7 days',
'teamPerformance.last30days': 'Last 30 days',
'teamPerformance.last90days': 'Last 90 days',
'teamPerformance.activeAttendants': 'Active attendants',
'teamPerformance.totalConversations': 'Total conversations',
'teamPerformance.appointments': 'Appointments',
'teamPerformance.avgResponseTime': 'Avg response time',
'teamPerformance.ranking': 'Attendants Ranking',
'teamPerformance.position': 'Position',
'teamPerformance.attendant': 'Attendant',
'teamPerformance.conversations': 'Conversations',
'teamPerformance.responseTime': 'Resp. Time',
'teamPerformance.conversion': 'Conversion',
'teamPerformance.satisfaction': 'Satisfaction',
'teamPerformance.noData': 'No data available',
'teamPerformance.min': 'min',
'teamPerformance.conv': 'conv.',
'teamPerformance.conversionByType': 'Conversion by Conversation Type',
'teamPerformance.conversionRate': 'Conversion Rate',

// Appointments
'appointments.title': 'Appointments',
'appointments.subtitle': 'Manage consultations and services',
'appointments.professionals': 'Professionals',
'appointments.registerProfessionals': 'Register Professionals',
'appointments.statistics': 'Statistics',
'appointments.sendReminders': 'Send Reminders',
'appointments.newAppointment': 'New Appointment',
'appointments.noSpecialty': 'No specialty',
'appointments.professional': 'PROFESSIONAL',
'appointments.allProfessionals': 'ALL PROFESSIONALS',
'appointments.fullSchedule': 'Full Schedule',
'appointments.appointmentsLower': 'appointments',
'appointments.confirmedLower': 'confirmed',
'appointments.noShows': 'no shows',
'appointments.searchPatient': 'Search patient...',
'appointments.all': 'All',
'appointments.scheduled': 'Scheduled',
'appointments.confirmed': 'Confirmed',
'appointments.completed': 'Completed',
'appointments.noShow': 'No Show',
'appointments.cancelled': 'Cancelled',
'appointments.time': 'Time',
'appointments.patient': 'Patient',
'appointments.contact': 'Contact',
'appointments.type': 'Type',
'appointments.observation': 'Observation',
'appointments.status': 'Status',
'appointments.actions': 'Actions',
'appointments.select': 'Select',
'appointments.fullName': 'Full name',
'appointments.typeConsultation': 'Consultation',
'appointments.typeReturn': 'Return',
'appointments.typeExam': 'Exam',
'appointments.typeProcedure': 'Procedure',
'appointments.typeUrgency': 'Urgency',
'appointments.observationPlaceholder': 'Ex: Bring previous exams...',
'appointments.schedule': 'Schedule',
'appointments.sendReminder': 'Send Reminder',
'appointments.messageToBeSent': 'Message to be sent',
'appointments.reminderMessage': 'Hello {name}! 👋\nWe remind you that you have an appointment scheduled for {date} at {time}.\nPlease confirm your presence by replying to this message. See you soon! 😊',
'appointments.sendVia': 'Send via',
'appointments.scheduleStatistics': 'Schedule Statistics',
'appointments.total': 'Total',
'appointments.attendanceRate': 'Attendance Rate',
'appointments.statusDistribution': 'Status Distribution',
// Appointments - Additional messages
'appointments.errorLoading': 'Error loading appointments',
'appointments.statusUpdated': 'Status updated to',
'appointments.errorUpdateStatus': 'Error updating status',
'appointments.observationSaved': 'Observation saved!',
'appointments.errorSaveObs': 'Error saving observation',
'appointments.fillRequiredFields': 'Please fill in the required fields',
'appointments.createdSuccess': 'Appointment created successfully!',
'appointments.errorCreate': 'Error creating appointment',
'appointments.confirmDelete': 'Remove this appointment?',
'appointments.deletedSuccess': 'Appointment removed',
'appointments.errorDelete': 'Error removing appointment',
'appointments.reminderSent': 'Reminder sent to',
'appointments.errorSendReminder': 'Error sending reminder',
'appointments.noPending': 'No pending appointments',
'appointments.confirmSendReminders': 'Send reminder to',
'appointments.remindersSent': 'Reminders sent to',
'appointments.patients': 'patients',

// BI Integration
'biIntegration.title': 'BI Integration',
'biIntegration.subtitle': 'Connect your data to Power BI or Google Data Studio',
'biIntegration.newIntegration': 'New Integration',
'biIntegration.powerBiDescription': 'Connect to Power BI via webhook for real-time updates',
'biIntegration.dataStudioDescription': 'Export data as CSV to connect to Google Data Studio',
'biIntegration.activeConfig': 'Active configuration',
'biIntegration.format': 'Format',
'biIntegration.autoExport': 'Auto-export',
'biIntegration.frequency': 'Frequency',
'biIntegration.lastExport': 'Last export',
'biIntegration.exportNow': 'Export Now',
'biIntegration.exporting': 'Exporting...',
'biIntegration.notConfigured': 'Not configured',
'biIntegration.configure': 'Configure',
'biIntegration.viewDocs': 'View documentation',
'biIntegration.configureConnection': 'Configure connection with your BI tool',
'biIntegration.biTool': 'BI Tool',
'biIntegration.webhookUrl': 'Webhook URL (Power BI)',
'biIntegration.apiKey': 'API Key (optional)',
'biIntegration.authKey': 'Authentication key',
'biIntegration.exportFormat': 'Export Format',
'biIntegration.exportFrequency': 'Export Frequency',
'biIntegration.freq_hourly': 'Hourly',
'biIntegration.freq_daily': 'Daily',
'biIntegration.freq_weekly': 'Weekly',
'biIntegration.configCreated': 'Configuration created successfully!',
'biIntegration.errorCreate': 'Error creating configuration',
'biIntegration.dataExported': 'Data exported to',
'biIntegration.errorExport': 'Error exporting',

// Achievements
'achievements.title': 'Achievements & Gamification',
'achievements.subtitle': 'Unlock medals and climb the ranking!',
'achievements.medalsWon': 'Medals won',
'achievements.totalPoints': 'Total points',
'achievements.rankingPosition': 'Ranking position',
'achievements.topMonth': 'Top 10 of the Month',
'achievements.you': 'you',
'achievements.achievementsLower': 'achievements',
'achievements.points': 'points',
'achievements.pts': 'pts',
'achievements.won': 'Won',
'achievements.locked': 'Locked',
'achievements.categorySpeed': 'Speed',
'achievements.categoryVolume': 'Volume',
'achievements.categoryQuality': 'Quality',
'achievements.categoryConversion': 'Conversion',

// Users
'users.title': 'User Management',
'users.subtitle': 'Manage profiles, permissions and team access.',
'users.newUser': 'New User',
'users.limitReached': 'Limit Reached',
'users.total': 'Total',
'users.active': 'Active',
'users.inactive': 'Inactive',
'users.planUsage': 'Plan Usage',
'users.plan': 'Plan',
'users.userLimitReached': 'User Limit Reached',
'users.allowsMax': 'allows maximum',
'users.usersLower': 'users',
'users.contactSupportUpgrade': 'To add more users, contact support or upgrade your plan.',
'users.searchPlaceholder': 'Search by name or email...',
'users.allProfiles': 'All profiles',
'users.roleAdmin': 'Administrator',
'users.roleManager': 'Manager',
'users.roleAttendant': 'Attendant',
'users.allStatuses': 'All statuses',
'users.user': 'User',
'users.email': 'Email',
'users.profile': 'Profile',
'users.sector': 'Sector',
'users.status': 'Status',
'users.actions': 'Actions',
'users.editUser': 'Edit User',
'users.limitReachedModal': 'Limit reached! Cannot create new users.',
'users.userPhoto': 'User Photo',
'users.fullName': 'Full name',
'users.fullNamePlaceholder': 'Ex: John Smith',
'users.emailPlaceholder': 'example@email.com',
'users.newPasswordKeep': 'New password (leave empty to keep)',
'users.password': 'Password',
'users.passwordMinChars': 'Minimum 6 characters',
'users.noSectorLinked': 'No linked sector',
'users.saveChanges': 'Save Changes',
'users.createUser': 'Create User',
  
// Tasks
'tasks.title': 'Tasks and Follow-up',
'tasks.subtitle': 'Manage your tasks and track deadlines',
'tasks.newTask': 'New Task',
'tasks.priorityLow': 'Low',
'tasks.priorityNormal': 'Normal',
'tasks.priorityHigh': 'High',
'tasks.priorityUrgent': 'Urgent',
'tasks.errorUpdateStatus': 'Error updating status',
'tasks.confirmDelete': 'Delete task?',
'tasks.errorDelete': 'Error deleting',
'tasks.overdueCount': '{count} overdue task(s)',
'tasks.dueOn': 'Due on',
'tasks.complete': 'Complete',
'tasks.allTasks': 'All Tasks',
'tasks.lead': 'Lead',
'tasks.responsible': 'Resp',
'tasks.noTasks': 'No tasks found.',
'tasks.editTask': 'Edit Task',
'tasks.titleField': 'Title',
'tasks.description': 'Description',
'tasks.noLinkedLead': 'No linked lead',
'tasks.noResponsible': 'No responsible',

// Chatbots
'chatbots.title': 'Chatbot',
'chatbots.subtitle': 'Automate first service with menu options',
'chatbots.newChatbot': 'New Chatbot',
'chatbots.updated': 'Chatbot updated!',
'chatbots.created': 'Chatbot created!',
'chatbots.errorUpdate': 'Error updating',
'chatbots.confirmDelete': 'Delete this chatbot?',
'chatbots.errorDelete': 'Error deleting',
'chatbots.fillAllOptionFields': 'Fill all option fields',
'chatbots.sectorNotFound': 'Sector not found',
'chatbots.totalSessions': 'Total Sessions',
'chatbots.completed': 'Completed',
'chatbots.waitingResponse': 'Waiting Response',
'chatbots.sessions': 'sessions',
'chatbots.completedLower': 'completed',
'chatbots.welcomeMessage': 'Welcome message',
'chatbots.question': 'Question',
'chatbots.options': 'Options',
'chatbots.more': 'more...',
'chatbots.default': 'Default',
'chatbots.noChatbots': 'No chatbots configured',
'chatbots.createFirst': 'Create your first chatbot to automate service',
'chatbots.editChatbot': 'Edit Chatbot',
'chatbots.configureAutoService': 'Configure automated service',
'chatbots.chatbotName': 'Chatbot Name',
'chatbots.namePlaceholder': 'Ex: Virtual Assistant',
'chatbots.welcomeMessageLabel': 'Welcome Message',
'chatbots.welcomePlaceholder': 'Ex: Hello! 👋 Welcome to our company.',
'chatbots.questionLabel': 'Question for Customer',
'chatbots.questionPlaceholder': 'Ex: To better direct you, choose an option:',
'chatbots.menuOptions': 'Menu Options',
'chatbots.menuOptionsHelp': 'Add options the customer can choose. Each option directs to a sector.',
'chatbots.addNewOption': 'Add new option:',
'chatbots.optionLabelPlaceholder': 'Ex: Scheduling',
'chatbots.selectSector': 'Sector...',
'chatbots.addOption': 'Add Option',
'chatbots.defaultSectorLabel': 'Default Sector (if customer does not choose valid option)',
'chatbots.noDefaultSector': 'None (leave unassigned)',
'chatbots.chatbotActive': 'Active Chatbot',
'chatbots.triggerOnNew': 'Trigger on new conversations',
'chatbots.preview': 'Message Preview',
'chatbots.typeOptionNumber': 'Type the option number:',
'chatbots.saveChanges': 'Save Changes',
'chatbots.createChatbot': 'Create Chatbot',

// Funnel
'funnel.title': 'Sales Funnel',
'funnel.subtitle': 'View and manage your opportunities',
'funnel.noConversations': 'No conversations in this stage',
'funnel.noMessages': 'No messages',
'funnel.high': 'High',
'funnel.medium': 'Medium',
'funnel.low': 'Low',
'funnel.conversationDetails': 'Conversation Details',

  // Languages
  'language.pt-BR': '🇧🇷 Portuguese',
  'language.en-US': '🇺🇸 English',
  'language.es-ES': '🇪🇸 Spanish',
  
  // Status
  'status.active': 'Active',
  'status.inactive': 'Inactive',
  'status.suspended': 'Suspended',
  'status.cancelled': 'Cancelled',
  'status.approved': 'Approved',
  'status.pending': 'Pending',
  
  // Roles
  'role.master_admin': 'Master Admin',
  'role.admin': 'Administrator',
  'role.tenant_admin': 'Company Admin',
  'role.manager': 'Manager',
  'role.attendant': 'Attendant',
  
  // Plans
  'plan.basic': 'Basic',
  'plan.professional': 'Professional',
  'plan.enterprise': 'Enterprise',
  
  // Master Admin
  'tenants.title': 'Companies Management',
  'tenants.subtitle': 'Manage all system companies',
  'tenants.addNew': 'Add New Company',
  'tenants.company': 'Company',
  'tenants.plan': 'Plan',
  'tenants.status': 'Status',
  'tenants.users': 'Users',
  'tenants.actions': 'Actions',
  'tenants.defaultLanguage': 'Default Language',
  'tenants.defaultLanguageHelp': 'Default language for new users of this company',
  
  // Settings
  'settings.title': 'Settings',
  'settings.subtitle': 'Configure your account and preferences',
};